import {
  PlaceOrderRequest,
  OrderHistoryResponse,
  UpdateProfileRequest,
  CamasysCustomerResponse
} from './types';
import axios, { AxiosError } from 'axios';
import { loopBackApi } from '../../models/LoopBack/Api/LoopBackApi';
import { getLogisticsAPIUrl } from '../../../services/env.service';

const logisticsApiUrl = getLogisticsAPIUrl();

class LogisticsClient {
  getOrderHistory(customerId: number) {
    const url = `customers/delivery-history/${customerId}`;

    return new Promise<OrderHistoryResponse>((resolve, reject) => {
      loopBackApi()
        .get<OrderHistoryResponse>(url)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err.message));
    });
  }

  getCamasysCustomer(customerId: number) {
    return new Promise<CamasysCustomerResponse>((resolve, reject) => {
      loopBackApi()
        .get(`customers/from-camasys/${customerId}`)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err.message));
    });
  }

  updateProfile(customerId: number, payload: UpdateProfileRequest) {
    const url = `${logisticsApiUrl}/customers/from-camasys/${customerId}`;

    return new Promise<void>((resolve, reject) => {
      axios
        .post(url, payload)
        .then(() => resolve())
        .catch(() =>
          reject(
            new Error(
              'Er is iets mis gegaan bij het opslaan van de gegevens. Probeer het later nogmaals of neem contact op'
            )
          )
        );
    });
  }

  placeOrder(payload: PlaceOrderRequest) {
    const url = `${logisticsApiUrl}/orders/place`;

    return new Promise<void>((resolve, reject) => {
      axios
        .post(url, payload)
        .then(() => resolve())
        .catch((axiosError) => {
          const error = axiosError as AxiosError;
          const status = (error && error.response && error.response.status) || null;

          let message = 'Er is een onbekende fout opgetreden';

          if (status === null) {
            message = 'Logistics is tijdelijk onbereikbaar. Probeer het later opnieuw.';
          } else if (status === 401 || status === 403) {
            message =
              'U heeft geen toegang om de bestelling te plaatsen. Probeer opnieuw in te loggen.';
          } else if (
            status === 400 &&
            error.response &&
            error.response.data.error &&
            error.response.data.error.message
          ) {
            message = error.response.data.error.message;
          }

          reject(new Error(message));
        });
    });
  }
}

const logisticsClient = new LogisticsClient();

export { logisticsClient };
